export default import.meta.ROLLDOWN_FILE_URL_eyckHw3eLYpWyD_hCZ4eHg